import { useState } from "react";
import { API_BASE } from "../../utils/api";
import { getLogoUrl } from "../../utils/config";
import { useHistory } from "react-router-dom";


export default function CompanyAccount() {
    const user = JSON.parse(localStorage.getItem("user"));
    const isSupervisor = user?.groupId === "     9";
    const history = useHistory();
    const [company, setCompany] = useState({
        name: user.companyName,
        ruc: user.cedula,
        city: user.city,
        address: user.address,
        phone: user.phone,
        emaile: user.eMaile,
        logoPreview: getLogoUrl(user.cedula, true),
        logo: null,
    });

    const handleChange = (e) => {
        setCompany({ ...company, [e.target.name]: e.target.value });
    };

    const handleLogoChange = (e) => {
        if (!isSupervisor) return;
        const file = e.target.files[0];
        if (!file) return;

        setCompany({
            ...company,
            logo: file,
            logoPreview: URL.createObjectURL(file),
        });

    };

    const handleSave = async () => {
        if (!isSupervisor) return;

        const formData = new FormData();

        // JSON como campo normal
        formData.append(
            "company",
            JSON.stringify({
                name: company.name,
                ruc: company.ruc,
                city: company.city,
                address: company.address,
                phone: company.phone,
                emaile: company.emaile,
            })
        );

        // Archivo binario
        if (company.logo) {
            formData.append("logo", company.logo);
        }

        const url =
            `${API_BASE}/customers-ultra/api/ws/put_update_customers` +
            `?myaccount_id=${user.myaccountId}` +
            `&cedula=${user.cedula}` +
            `&id_customer=${user.idCustomer}`;

        try {
            const res = await fetch(url, {
                method: "POST",
                body: formData, // 👈 IMPORTANTE: sin headers
            });

            if (!res.ok) throw new Error("Error actualizando empresa");

            // 1️⃣ Actualizar localStorage.user
            const updatedUser = {
                ...user,
                companyName: company.name,
                cedula: company.ruc,
                city: company.city,
                address: company.address,
                phone: company.phone,
                eMaile: company.emaile,
            };

            localStorage.setItem("user", JSON.stringify(updatedUser));

            setTimeout(() => {
                window.location.reload();
            }, 300);
        } catch (e) {
            console.error("Error actualizando empresa", e);
        }
    };



    return (
        <div className="max-w-6xl mx-auto mt-24 px-4">

            <div className="flex items-center justify-between mb-6">
                <div>
                    <h1 className="text-2xl font-semibold mb-1">Empresa / Cuenta</h1>
                    <p className="text-gray-500">
                        Información general de la empresa
                    </p>
                </div>

                <button
                    onClick={() => history.goBack()}
                    className="px-4 py-2 border rounded hover:bg-gray-100 transition text-sm"
                >
                    ← Regresar
                </button>
            </div>
            {/* CONTENEDOR PRINCIPAL */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">

                {/* DATOS EMPRESA */}
                <div className="lg:col-span-2 bg-white border rounded-xl p-8">
                    <h2 className="font-medium mb-6 text-gray-800">
                        Datos de la empresa
                    </h2>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                        <div>
                            <label className="block text-sm text-gray-600 mb-1">
                                Nombre de la empresa
                            </label>
                            <input
                                name="name"
                                value={company.name}
                                onChange={handleChange}
                                disabled={true}
                                className="w-full border px-3 py-2 rounded disabled:bg-gray-100"
                            />
                        </div>

                        <div>
                            <label className="block text-sm text-gray-600 mb-1">
                                RUC
                            </label>
                            <input
                                name="ruc"
                                value={company.ruc}
                                onChange={handleChange}
                                disabled={true}
                                className="w-full border px-3 py-2 rounded disabled:bg-gray-100"
                            />
                        </div>

                        <div>
                            <label className="block text-sm text-gray-600 mb-1">
                                Teléfono
                            </label>
                            <input
                                name="phone"
                                value={company.phone}
                                onChange={handleChange}
                                disabled={!isSupervisor}
                                className="w-full border px-3 py-2 rounded disabled:bg-gray-100"
                            />
                        </div>

                        <div>
                            <label className="block text-sm text-gray-600 mb-1">
                                Ciudad
                            </label>
                            <input
                                name="city"
                                value={company.city}
                                onChange={handleChange}
                                disabled={!isSupervisor}
                                className="w-full border px-3 py-2 rounded disabled:bg-gray-100"
                            />
                        </div>

                        <div className="md:col-span-2">
                            <label className="block text-sm text-gray-600 mb-1">
                                Dirección
                            </label>
                            <input
                                name="address"
                                value={company.address}
                                onChange={handleChange}
                                disabled={!isSupervisor}
                                className="w-full border px-3 py-2 rounded disabled:bg-gray-100"
                            />
                        </div>

                        <div className="md:col-span-2">
                            <label className="block text-sm text-gray-600 mb-1">
                                Email de contacto
                            </label>
                            <input
                                name="emaile"
                                value={company.emaile}
                                onChange={handleChange}
                                disabled={!isSupervisor}
                                className="w-full border px-3 py-2 rounded disabled:bg-gray-100"
                            />
                        </div>
                    </div>

                    {isSupervisor && (
                        <div className="mt-8">
                            <button
                                onClick={handleSave}
                                className="bg-brand-primary text-white px-6 py-2 rounded hover:opacity-90"
                            >
                                Guardar cambios
                            </button>
                        </div>
                    )}
                </div>

                {/* LOGO */}
                <div className="bg-white border rounded-xl p-8 flex flex-col items-center justify-center">

                    <div className="w-56 h-40 md:w-64 md:h-44 flex items-center justify-center border rounded mb-6 bg-gray-50">
                        <img
                            src={company.logoPreview}
                            onError={(e) => { e.currentTarget.src = "https://www.ultra-erp.pro/products/no_image.jpg"; }}
                            alt="Logo empresa"
                            className="max-w-48 md:max-w-56 max-h-36 object-contain"
                        />

                    </div>

                    {isSupervisor ? (
                        <label className="cursor-pointer">
                            <input
                                type="file"
                                accept="image/*"
                                onChange={handleLogoChange}
                                className="hidden"
                            />
                            <span className="px-4 py-2 border rounded text-sm hover:bg-gray-100">
                                Cambiar logo
                            </span>
                        </label>
                    ) : (
                        <span className="text-sm text-gray-400">

                        </span>
                    )}
                </div>


            </div>
        </div>
    );
}
